document.addEventListener("DOMContentLoaded", function () {
  if ($('form.form-devis-1').length > 0) {
    const carContainer = $('.brand-container'),
      listMakes = $('#listMakes'),
      listModels = $('#listModels'),
      listTypes = $('#listTypes'),
      licenseError = $('span#error-immatriculation'),
      makeIdInput = $('input#make_id'),
      modelIdInput = $('input#model_id'),
      vehicleIdInput = $('input#vehicle_id'),
      vehicleNameInput = $('input#vehicle_name'),
      vinNumber = $('input#chassis'),
      vinError = $('span#error-vin'),
      carLicense = $('input#license'),
      selects = ['prestation', 'listMakes', 'listModels' , 'listTypes'];

    $(selects).each(function () {
      if ($('select#' + this).length > 0) {
        $('select#' + this).select2(
          {
            theme: "devis",
            dropdownAutoWidth: true
          }
        );
      }
    });

    $("form.form-devis-1").submit(function(e) {
      e.preventDefault();

      let form = this;
      $('.form-devis-1 .btn-submit').append("<img class='load-wait' src='" + translations.theme_path + "/assets/img/ajax-loader.svg' style='margin-left: 10px; width:1em; height: 1em;'>");
      $('.form-devis-1 .btn-submit').addClass('bg-grey');
      $('.form-devis-1 .btn-submit').attr("disabled", true);

      vinError.addClass('hidden');
      licenseError.addClass('hidden');

      if(vinNumber.length > 0 && vinNumber.val().length > 1) {
        let vin = vinNumber.val();
        $.ajax({
          type: 'POST',
          url: translations.ajaxurl,
          data: {
            action: 'vin_identification',
            vin: vin
          }
        }).done(function(response) {
          if (!response.success) {
            vinError.removeClass('hidden');
            vinError.text(response.data.message);
            carContainer.removeClass('hidden');

            $('.form-devis-1 .btn-submit img.load-wait').remove();
            $('.form-devis-1 .btn-submit').removeClass('bg-grey');
            $('.form-devis-1 .btn-submit').attr("disabled", false);
          } else {
            vinError.addClass('hidden');
            carContainer.addClass('hidden');

            let vehicle = response.data.vehicle,
              make_id = vehicle.version.model.make.id,
              model_id = vehicle.version.model.id,
              vehicle_id = vehicle.id,
              vehicle_name =  vehicle.version.model.make.label + ' ' + vehicle.label;

            $('select#listTypes').val(vehicle_id);
            makeIdInput.val(make_id);
            modelIdInput.val(model_id);
            vehicleIdInput.val(vehicle_id);
            vehicleNameInput.val(vehicle_name);

            executeForm(form);
          }
        });
      } else if(carLicense.length > 0 && carLicense.val().length === 9) {
        let license = carLicense.val();
        $.ajax({
          type: 'POST',
          url: translations.ajaxurl,
          data: {
            action: 'car_identification',
            license: license
          }
        }).done(function(data) {

          let response = $.parseJSON(data);

          if (response.Error) {
            licenseError.removeClass('hidden');
            licenseError.addClass('show');

            $('.form-devis-1 .btn-submit img.load-wait').remove();
            $('.form-devis-1 .btn-submit').removeClass('bg-grey');
            $('.form-devis-1 .btn-submit').attr("disabled", false);
          } else {
            licenseError.removeClass('show');
            licenseError.addClass('hidden');

            let make_id = response[0].version.model.make.id,
              model_id = response[0].version.model.id,
              vehicle_id = response[0].id,
              vehicle_name =  response[0].version.model.make.label + ' ' + response[0].label;

            $('select#listTypes').val(vehicle_id);
            makeIdInput.val(make_id);
            modelIdInput.val(model_id);
            vehicleIdInput.val(vehicle_id);
            vehicleNameInput.val(vehicle_name);

            executeForm(form);
          }
        });
      } else {
        executeForm(form);
      }
    });

    function executeForm(form) {
      let placeNameVal = $('input#place_name').val(),
        placeIdVal = $('input#place_id').val(),
        placeLatVal = $('input#place_lat').val(),
        placeLngVal = $('input#place_lng').val(),
        prestationVal = $('select#prestation').val(),
        listMakesVal = $('select#listMakes option').length > 1 && $('select#listMakes').val() ? $('select#listMakes').val() : makeIdInput.val(),
        listModelsVal = $('select#listModels option').length > 1 && $('select#listModels').val() ? $('select#listModels').val() : modelIdInput.val(),
        listTypesVal = $('select#listTypes option').length > 1 && $('select#listTypes').val() ? $('select#listTypes').val() : vehicleIdInput.val(),
        placeNameError = $('span#error-localisation'),
        prestationError = $('span#error-prestation'),
        listMakesError =  $('span#error-listmakes'),
        listModelsError = $('span#error-listmodels'),
        listTypesError = $('span#error-listtypes'),
        errorsCount = 0;

      $.ajax({
        type: 'POST',
        url: translations.ajaxurl,
        data: {
          action: 'verify_service',
          service_id: prestationVal,
          vehicle_id: listTypesVal
        }
      }).done(function(data) {
        let response = $.parseJSON(data);

        if (!placeNameVal || !placeIdVal || !placeLatVal || !placeLngVal) {
          errorsCount++;
          placeNameError.removeClass('hidden');
          placeNameError.addClass('show');
        } else {
          placeNameError.removeClass('show');
          placeNameError.addClass('hidden');
        }

        if (!prestationVal) {
          errorsCount++;
          prestationError.removeClass('hidden');
          prestationError.addClass('show');
        } else {
          prestationError.removeClass('show');
          prestationError.addClass('hidden');
        }

        if(carLicense.length < 1 || carLicense.val().length < 9) {
          if (!listMakesVal) {
            errorsCount++;
            listMakesError.removeClass('hidden');
            listMakesError.addClass('show');
          } else {
            listMakesError.removeClass('show');
            listMakesError.addClass('hidden');
          }

          if (!listModelsVal) {
            errorsCount++;
            listModelsError.removeClass('hidden');
            listModelsError.addClass('show');
          } else {
            listModelsError.removeClass('show');
            listModelsError.addClass('hidden');
          }

          if (!listTypesVal) {
            errorsCount++;
            listTypesError.removeClass('hidden');
            listTypesError.addClass('show');
          } else {
            listTypesError.removeClass('show');
            listTypesError.addClass('hidden');
          }
        }

        if (!response.success) {
          errorsCount++;
          $('#service-error').html(response.message);
          $('#service-error').addClass('show');
          $('#service-error').removeClass('hidden');
        } else {
          $('#service-error').html('');
          $('#service-error').removeClass('show');
          $('#service-error').addClass('hidden');
        }

        if (errorsCount === 0) {
          form.submit();
        } else {
          $('.form-devis-1 .btn-submit img.load-wait').remove();
          $('.form-devis-1 .btn-submit').removeClass('bg-grey');
          $('.form-devis-1 .btn-submit').attr("disabled", false);
        }
      });
    }

    function getModels(el, init = 0) {

      let $modelContainer = $('.select-model-container');

      if ($modelContainer.length > 0) {
        $modelContainer.removeClass('hidden');
      }

      let input  = $(el).val();

      $('#select2-listModels-container').parent().find('.select2-selection__arrow').removeClass('select2-selection__arrow').addClass('load').append("<img class='load-wait' src='" + translations.theme_path + "/assets/img/ajax-loader.svg' alt='loading' style='width:15px;height:15px;float:right;'>");
      listModels.find('optgroup, option').remove();
      listTypes.find('optgroup, option').remove();

      $.ajax({
        type: 'POST',
        url: translations.ajaxurl,
        data: {
          action: 'get_make_models',
          input: input,
          model_select : translations.model_select
        }
      }).done(function(response) {
        listModels.html(response);
        if (translations.model_id) {
          $('#listModels option[value="' + translations.model_id + '"]').prop('selected', true).trigger('change');
        }
        $('#select2-listModels-container').parent().find('.load').removeClass('load').addClass('select2-selection__arrow').find('img.load-wait').remove();
        if (init && listModels.val() !== null) {
          getVehicles(listModels);
        }
      });
    }

    function getVehicles(el) {

      let $typeContainer = $('.select-type-container');

      if ($typeContainer.length > 0) {
        $typeContainer.removeClass('hidden');
      }

      $('#select2-listTypes-container').parent().find('.select2-selection__arrow').removeClass('select2-selection__arrow').addClass('load').append("<img class='load-wait' src='" + translations.theme_path + "/assets/img/ajax-loader.svg' alt='loading' style='width:15px;height:15px;float:right;'>");
      listTypes.find('optgroup, option').remove();

      let version  = $(el).val(),
        model = $(el).find(':selected').data('model'),
        make = $(el).find(':selected').data('make');

      $.ajax({
        type: 'POST',
        url: translations.ajaxurl,
        data: {
          action: 'get_vehicles',
          version: version,
          model: model,
          make: make,
          vehicle_select: translations.vehicle_select
        }
      }).done(function(response) {
        listTypes.html(response);
        if (translations.vehicle_id) {
          $('#listTypes option[value="' + translations.vehicle_id + '"]').prop('selected', true).trigger('change');
        }
        $('#select2-listTypes-container').parent().find('.load').removeClass('load').addClass('select2-selection__arrow').find('img.load-wait').remove();
      });
    }

    if (listMakes.val() !== null) {
      getModels(listMakes, true);
    }

    listMakes.on("change",function() {
      getModels(this);
      emptyVin();
      emptyPlate();
    });

    listModels.on("change",function() {
      getVehicles(this);
      emptyVin();
      emptyPlate();
    });

    listTypes.on("change",function() {
      vehicleNameInput.val($(this).find(':selected').text());
      emptyVin();
      emptyPlate();
    });

    function emptyVin() {
      if (vinNumber && vinNumber.val() && vinNumber.val().length > 0) {
        vinNumber.val('');
      }
    }

    function emptyPlate() {
      if (carLicense && carLicense.val() && carLicense.val().length > 0) {
        carLicense.val('');
      }
    }
  }

  if ($('form.form-client-data').length > 0) {
    $("form.form-client-data").submit(function () {
      let identifiedByLicense = $('input#identified_by_license').val(),
        calendarDateVal = $('input#calendar_date').val(),
        hoursVal = $('select#hours').val(),
        kmsVal = $('input[name=kms]').val(),
        firstnameVal = $('input[name=firstname]').val(),
        lastnameVal = $('input[name=lastname]').val(),
        emailVal = $('input[name=email]').val(),
        addressVal = $('input[name=user_address]').val(),
        zipVal = $('input[name=user_zip]').val(),
        cityVal = $('input[name=user_city]').val(),
        phoneVal = $('input[name=phone]').val(),
        acceptVal = $('input[name=accept]').is(":checked"),
        acceptCgvVal = $('input[name=accept-cgv]').is(":checked"),
        calendarDateError = $('span#error-calendar_date'),
        hoursError = $('span#error-hours'),
        kmsError = $('span#error-kms'),
        firstnameError = $('span#error-firstname'),
        lastnameError = $('span#error-lastname'),
        emailError = $('span#error-email'),
        addressError = $('span#error-address'),
        zipError = $('span#error-zip'),
        cityError = $('span#error-city'),
        phoneError = $('span#error-phone'),
        acceptError = $('span#error-accept'),
        acceptCgvError = $('span#error-accept-cgv'),
        errorsCount = 0;

      $('.form-client-data .btn-submit').append("<img class='load-wait' src='" + translations.theme_path + "/assets/img/ajax-loader.svg' style='margin-left: 10px; width:1em; height: 1em;'>");
      $('.form-client-data .btn-submit').addClass('bg-grey');
      $('.form-client-data .btn-submit').attr("disabled", true);

      if (!calendarDateVal) {
        errorsCount++;
        calendarDateError.removeClass('hidden');
        calendarDateError.addClass('show');
      } else {
        calendarDateError.removeClass('show');
        calendarDateError.addClass('hidden');
      }

      if (!hoursVal) {
        errorsCount++;
        hoursError.removeClass('hidden');
        hoursError.addClass('show');
      } else {
        hoursError.removeClass('show');
        hoursError.addClass('hidden');
      }

      if (!identifiedByLicense) {
        if (!kmsVal) {
          errorsCount++;
          kmsError.removeClass('hidden');
          kmsError.addClass('show');
        } else {
          kmsError.removeClass('show');
          kmsError.addClass('hidden');
        }
      }

      if (!firstnameVal) {
        errorsCount++;
        firstnameError.removeClass('hidden');
        firstnameError.addClass('show');
      } else {
        firstnameError.removeClass('show');
        firstnameError.addClass('hidden');
      }

      if (!lastnameVal) {
        errorsCount++;
        lastnameError.removeClass('hidden');
        lastnameError.addClass('show');
      } else {
        lastnameError.removeClass('show');
        lastnameError.addClass('hidden');
      }

      if (!addressVal) {
        errorsCount++;
        addressError.removeClass('hidden');
        addressError.addClass('show');
      } else {
        addressError.removeClass('show');
        addressError.addClass('hidden');
      }

      if (!zipVal) {
        errorsCount++;
        zipError.removeClass('hidden');
        zipError.addClass('show');
      } else {
        zipError.removeClass('show');
        zipError.addClass('hidden');
      }

      if (!cityVal) {
        errorsCount++;
        cityError.removeClass('hidden');
        cityError.addClass('show');
      } else {
        cityError.removeClass('show');
        cityError.addClass('hidden');
      }

      if (!emailVal || !isEmail(emailVal)) {
        errorsCount++;
        emailError.removeClass('hidden');
        emailError.addClass('show');
      } else {
        emailError.removeClass('show');
        emailError.addClass('hidden');
      }

      if (!phoneVal) {
        errorsCount++;
        phoneError.removeClass('hidden');
        phoneError.addClass('show');
      } else {
        phoneError.removeClass('show');
        phoneError.addClass('hidden');
      }

      if (!acceptVal) {
        errorsCount++;
        acceptError.removeClass('hidden');
        acceptError.addClass('show');
      } else {
        acceptError.removeClass('show');
        acceptError.addClass('hidden');
      }

      if (!acceptCgvVal) {
        errorsCount++;
        acceptCgvError.removeClass('hidden');
        acceptCgvError.addClass('show');
      } else {
        acceptCgvError.removeClass('show');
        acceptCgvError.addClass('hidden');
      }

      if (errorsCount === 0) {
        return true;
      }

      $('.form-client-data .btn-submit img.load-wait').remove();
      $('.form-client-data .btn-submit').removeClass('bg-grey');
      $('.form-client-data .btn-submit').attr("disabled", false);

      return false;
    });
  }

  function isEmail(email) {
    let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    return regex.test(email);
  }
});